import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {SPACING} from '../../../constants/sizing';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {PriceV2} from '../../../types/Price';

interface LowestProductPrice30DWithRichTextProps {
  lpl30d: PriceV2['lpl30d'];
  className?: string;
  align?: 'left' | 'right';
  overflowHiddenLPL30D?: boolean;
}

export const LowestProductPrice30DWithRichText: FC<
  LowestProductPrice30DWithRichTextProps
> = ({lpl30d, className, align = 'left', overflowHiddenLPL30D}) => {
  if (!lpl30d) {
    return null;
  }

  return (
    <Wrapper
      className={className}
      data-testid="lowestProductPrice30D"
      data-align={align}
      $flexWrap={!overflowHiddenLPL30D}
    >
      <Text
        data-label="true"
        dangerouslySetInnerHTML={{__html: lpl30d.label.text}}
        data-overflow-lpl30d={overflowHiddenLPL30D}
      />
      <Text
        data-value="true"
        dangerouslySetInnerHTML={{__html: lpl30d.value.text}}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{$flexWrap?: boolean}>`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: ${props => (props.$flexWrap ? 'wrap' : 'inherit')};

  &[data-align='right'] {
    justify-content: flex-end;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SPACING['X.Xs']};

  &[data-overflow-lpl30d='true'] {
    max-width: 130px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  span {
    font-size: ${FONT_SIZES.px9};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    line-height: 1.5;
  }

  &[data-label='true'] span {
    color: ${COLORS['Text.Grey']};
  }
`;
